import React from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { RebookImportantInfoProps } from "./types";

export const useRebookImportantInfo = (props: RebookImportantInfoProps) => {
  const { t, formatFiatCurrency } = useI18nContext();

  return React.useMemo(
    () => ({
      text: {
        title: t("core-flights.rebook.summary.important-info.title"),
        rebookingAmountCap: formatFiatCurrency(
          {
            value: 5000,
            currencyCode: "USD",
          },
          { minimumFractionDigits: 0, maximumFractionDigits: 0 }
        ),
        supportNumber: "844-422-6922",
      },
    }),
    [formatFiatCurrency, t]
  );
};
